// extracted by mini-css-extract-plugin
export default {"navbar":"Footer_navbar__r+HYn","applogo":"Footer_applogo__cDNoW"};